import { useState } from 'react'

const useAlert = () => {
    const initialAlertInfo = { theme: '', message: '', visible: false }
    const [alertInfo, setAlertInfo] = useState(initialAlertInfo)

    const setAllAlertInfo = (allStatus: any) => {
        setAlertInfo(allStatus)
    }

    const setInitialAlertInfo = () => {
        setAlertInfo(initialAlertInfo)
    }

    return {
        alertInfo: alertInfo,
        setAllAlertInfo,
        setInitialAlertInfo,
    }
}

export default useAlert
